import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=2e99944a&scoped=true&"
import script from "./comments.vue?vue&type=script&lang=js&"
export * from "./comments.vue?vue&type=script&lang=js&"
import style0 from "./comments.vue?vue&type=style&index=0&id=2e99944a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e99944a",
  null
  
)

export default component.exports